import React, { useState } from "react";
import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "./domainUseCaseLayout";
import BFSIProcessFlow from "./BFSIProcessFlow";
import UseCaseIndexGrid from "./UseCaseIndexGrid";
import DomainSeoHelmet from "./DomainSeoHelmet";
import DomainHiddenSeoContent from "./DomainHiddenSeoContent";

import {
  BFSI_DOMAIN_INTRO,
  BFSI_GROUPS,
  BFSI_USE_CASES_SEO,
  BFSI_DOMAIN_FAQS,
  BFSI_ITEM_LIST_JSONLD,
  BFSI_BREADCRUMB_JSONLD,
  BFSI_WEBPAGE_JSONLD,
  BFSI_FAQ_JSONLD,
} from "../../data/bfsiUseCases";


function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={<BFSIProcessFlow useCaseId={useCase.id} />}
    />
  );
}

function GroupSection({ group }) {
  const cases = BFSI_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;

  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>{group.label}</h2>
      <div className="fin-list">
        {cases.map((uc) => (
          <UseCaseCard key={uc.id} useCase={uc} />
        ))}
      </div>
    </section>
  );
}

export default function BFSIDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");

  const visibleGroups =
    activeFilter === "all"
      ? BFSI_GROUPS
      : BFSI_GROUPS.filter((group) => group.id === activeFilter);

  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={BFSI_DOMAIN_INTRO}
        domainSlug="bfsi-domain"
        useCaseCount={BFSI_USE_CASES_SEO.length}
        groupCount={BFSI_GROUPS.length}
        itemListJsonLd={BFSI_ITEM_LIST_JSONLD}
        breadcrumbJsonLd={BFSI_BREADCRUMB_JSONLD}
        faqJsonLd={BFSI_FAQ_JSONLD}
        webPageJsonLd={BFSI_WEBPAGE_JSONLD}
      />
      <style>{DOMAIN_PAGE_STYLES}</style>

      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{BFSI_DOMAIN_INTRO.title}</h1>
          {BFSI_DOMAIN_INTRO.content ? (
            <p>{BFSI_DOMAIN_INTRO.content}</p>
          ) : null}
        </div>
      </header>

      <UseCaseIndexGrid
        useCases={BFSI_USE_CASES_SEO}
        groups={BFSI_GROUPS}
        heading="BFSI Use Cases"
        onFilterChange={setActiveFilter}
      />

      <div className="fin-wrap">
        {visibleGroups.map((group) => (
          <GroupSection key={group.id} group={group} />
        ))}
      </div>
      <DomainHiddenSeoContent
        domainTitle={BFSI_DOMAIN_INTRO.title}
        domainFaqs={BFSI_DOMAIN_FAQS}
        useCases={BFSI_USE_CASES_SEO}
      />
    </div>
  );
}

